export default __webpack_public_path__ + "static/media/diving-eagle.2ccdb026.svg";